<template>
  <tr>
    <td
      class="boss-table-data"
      data-test="option-type"
    >
      {{ option.isPhotoClip ? 'フォトクリップ' : 'インタビュー' }}
    </td>
    <td
      class="boss-table-data"
      data-test="option-title"
    >
      {{ option.title }}
    </td>
    <td
      class="boss-table-data"
      data-test="publish-date"
    >
      {{ option.startDate | formatDate }} ~ {{ option.endDate | formatDate }}
    </td>
    <td class="boss-table-data">
      <button
        v-if="option.isPhotoClip"
        class="boss-button"
        data-test="photo-clip-button"
        @click="windowOpenPreview('photoClipPublishedPreview', option.id)"
      >
        フォトクリップ
      </button>
      <button
        v-else
        class="boss-button"
        data-test="interview-button"
        @click="windowOpenPreview('interviewPublishedPreview', option.id)"
      >
        インタビュー
      </button>
    </td>
  </tr>
</template>

<script>
import dayjs from 'dayjs'

export default {
  filters: {
    formatDate (val) {
      return dayjs(val).format('YYYY/MM/DD')
    }
  },
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  methods: {
    windowOpenPreview (name, id) {
      const routeData = this.$router.resolve({ name: name, params: { id: id } })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
